import { MAIL } from 'newJs/config';

const { MODE_NAMES: CMN } = MAIL.get('COMPOSE');
const tpl = new Map();

/* -- Compose email body -- */
tpl.set('compose', (currentMode = 'reply', data) => {
    const { body = '', date = '', from = '', subject = '', to = '' } = data;
    const isReply = [CMN.REPLY, CMN.REPLY_ALL].includes(currentMode);

    return `
        <br />
        <br />
        <div class="noTransl">
            ----- ${isReply ? 'Reply to' : 'Forwarded'} message -----<br />
            <strong>Subject:</strong> ${subject}<br />
            <strong>Date:</strong> ${date}<br />
            <strong>From:</strong> ${from}<br />
            <strong>To:</strong> ${to}
        </div>
        <br />
        <blockquote>
            ${body}
        </blockquote>
    `;
});

export default tpl;
